import { FormDataSourceImplementation } from "elementInterfaces";

export function buildActions(dataSource: FormDataSourceImplementation) {
  return {
    click: dataSource.reset,
  };
}
